/**
 * Return `true` if the type of `x` satisfies `Record<PropertyKey, unknown>`.
 *
 * Note that this function returns `true` for ambiguous instances like `Set`, `Map`, `Date`, `Promise`, etc.
 * Use {@linkcode [is/record-object].isRecordObject|isRecordObject} instead if you want to check if `x` is an instance of `Object`.
 *
 * ```ts
 * import { is } from "@core/unknownutil";
 *
 * const a: unknown = {"a": 0, "b": 1};
 * if (is.Record(a)) {
 *   const _: Record<PropertyKey, unknown> = a;
 * }
 *
 * const b: unknown = new Set();
 * if (is.Record(b)) {
 *   const _: Record<PropertyKey, unknown> = b;
 * }
 * ```
 */
export function isRecord(
  x: unknown,
): x is Record<PropertyKey, unknown> {
  return x != null && !Array.isArray(x) && typeof x === "object";
}

// denoCacheMetadata={"headers":{"content-type":"text/typescript","access-control-allow-origin":"*","x-goog-stored-content-encoding":"identity","x-content-type-options":"nosniff","age":"91","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","content-length":"770","x-guploader-uploadid":"AHmUCY2cNd0pAZiHLOR2XSrRBrr8jWzk2nVDKINUJ1IpWBXx_WzQOxgSkpjyInOgk0rMbnrXJyXWCT9Y6w","server":"UploadServer","expires":"Sat, 08 Nov 2025 10:08:30 GMT","x-goog-metageneration":"1","etag":"\"4cebb990822d5dc4912c6345b593812b\"","x-jsr-cache-status":"hit","cache-control":"public, max-age=31536000, immutable","cross-origin-resource-policy":"cross-origin","x-goog-generation":"1724458185446111","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","x-jsr-cache-id":"IAD","x-robots-tag":"noindex","x-goog-storage-class":"STANDARD","access-control-expose-headers":"*","date":"Fri, 08 Nov 2024 10:08:30 GMT","x-goog-stored-content-length":"770","x-goog-hash":"crc32c=kQnKDA==,md5=TOu5kIItXcSRLGNFtZOBKw==","accept-ranges":"bytes","via":"1.1 google","last-modified":"Sat, 24 Aug 2024 00:09:45 GMT"},"url":"https://jsr.io/@core/unknownutil/4.3.0/is/record.ts","time":1731060600}